import {Component, DestroyRef, OnInit} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {RoutingStateService} from './shared/services/routing/routing-state.service';
import {UsageAnalyticsService} from './shared/services/usage-analytics/usage-analytics.service';
import {UserProfileService} from '@shared/services/api/user-profile.service';
import {FaviconService} from '@shared/services/util/favicon.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {

  loading = true;

  constructor(private router: Router, routingStateService: RoutingStateService,
              private usageAnalyticsService: UsageAnalyticsService,
              private userProfileService: UserProfileService,
              private faviconService: FaviconService,
              private destroyRef: DestroyRef) {
    routingStateService.loadRouting();
  }

  ngOnInit() {
    this.usageAnalyticsService.track('App Load', {url: this.router.url});

    this.userProfileService.authenticatedUser$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(loggedInUser => {
        if (!loggedInUser?.userEntity?.getHideBranding()) {
          this.faviconService.addFavicon();
        }
      });

    // prevent unsafe eval in vis-data which triggers CSP error
    // https://github.com/facebook/regenerator/issues/378#issuecomment-765141043
    globalThis.regeneratorRuntime = undefined
  }

  onRouterOutletActivate(event: any) {
    this.loading = false;
  }
}
